import { BillingSubscriptionRecord, fromJSON } from "common/records/BillingSubscription";
import { List, Map, Record } from "immutable";
import {
  RECEIVE_BILLING_SUBSCRIPTIONS,
  SET_BILLING_LOADING,
  SET_SESSION_URL,
  SET_BILLING_KIND,
} from "common/reducers/billing.actions";
import { RootActions, RootState } from "common/reducers";
import { Nullable } from "common/types";

export const BillingStateRecord = Record({
  byOrgId: Map<number, List<BillingSubscriptionRecord>>(),
  sessionUrl: null as Nullable<string>,
  loading: false,
  kind: "maxio",
});

export const initialState = BillingStateRecord();
export type BillingState = typeof initialState;

export const initialBillingRecord = Record({ billing: initialState })();
export type BillingRootRecord = typeof initialBillingRecord;

const model = "billing";
export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.get(model)) {
    state = state.set(model, initialState);
  }
  switch (action.type) {
    case RECEIVE_BILLING_SUBSCRIPTIONS:
      state = state.setIn([model, "loading"], false);

      return state.setIn(
        [model, "byOrgId", action.payload.orgId],
        List(action.payload.subscriptions.map((item) => fromJSON(item))),
      );

    case SET_SESSION_URL:
      return state.setIn([model, "sessionUrl"], action.payload.url).setIn([model, "loading"], false);

    case SET_BILLING_LOADING:
      return state.setIn([model, "loading"], action.payload.loading);

    case SET_BILLING_KIND:
      return state.setIn([model, "kind"], action.payload.kind);

    default:
      return state;
  }
};
